import { NativeHandoffScreen } from '@/components/NativeHandoffScreen';
import { TransitionToNativeAppScreen } from '@/components/TransitionToNativeAppScreen';
import { getNativeAppClientInfo } from '@/modules/clientContext';

export default function TransitionToNativeApp() {
  // The transition screen (QR + app download) is a WEB terminal — it makes no
  // sense inside the native app. Native users hand the session back to the app
  // (sesame → handleAuth) and dismiss the WebView instead; they never see this
  // screen.
  if (getNativeAppClientInfo().isLoadedInNativeApp) {
    return <NativeHandoffScreen />;
  }

  return <TransitionToNativeAppScreen />;
}
